import Hero from '../modules/Hero';
import Homecards from '../modules/Homecards';
import Linking from '../modules/Linking';

export default {
  HeroModule: Hero,
  HomecardsModule: Homecards,
  LinkingModule: Linking
};
